import { render } from "./FileModal.vue?vue&type=template&id=8819aecc&scoped=true"
import script from "./FileModal.vue?vue&type=script&lang=js"
export * from "./FileModal.vue?vue&type=script&lang=js"

import "./FileModal.vue?vue&type=style&index=0&id=8819aecc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8819aecc"

export default script